import cx from "classnames";

interface UsageCompletionBarProps {
  percent: number | null;
  fillColor?: string;
  fillClassName?: string;
  className?: string;
  barClassName?: string;
  benchmarkPercent?: number;
}

function UsageCompletionBar({
  percent,
  fillColor,
  fillClassName,
  className,
  barClassName,
  benchmarkPercent,
}: UsageCompletionBarProps) {
  if (percent === null) {
    return <span className="text-gray-500">-</span>;
  }

  const safePercent = Math.min(100, Math.max(0, percent));

  return (
    <div className={cx("inline-flex items-center gap-2", className)}>
      <div
        className={cx(
          "relative h-2 w-[60px] overflow-hidden rounded-full bg-gray-100",
          barClassName,
        )}
        aria-hidden
      >
        <div
          className={cx("h-full rounded-full", fillClassName)}
          style={{
            width: `${safePercent}%`,
            backgroundColor: fillColor,
          }}
        />
        {benchmarkPercent !== undefined && (
          <span
            className="absolute inset-y-0 w-px bg-gray-700"
            style={{
              left: `${Math.min(99.5, Math.max(0, benchmarkPercent))}%`,
            }}
          />
        )}
      </div>
      <span className="text-sm tabular-nums text-gray-700">{safePercent}%</span>
    </div>
  );
}

export default UsageCompletionBar;
